
import { defineComponent, ref, onMounted, onUnmounted } from 'vue';

export default defineComponent({
  name: 'DisplayCurrentTimer',

  setup() {
    const currentTime = ref(new Date().toLocaleString());
    let timer: number | null = null;

    onMounted(() => {
      // 1秒ごとに時刻を更新
      timer = window.setInterval(() => {
        currentTime.value = new Date().toLocaleString();
      }, 1000);
    });

    // コンポーネントの破棄時にタイマーをクリア
    onUnmounted(() => {
      if (timer) {
        clearInterval(timer);
      }
    });

    return {
      currentTime,
    };
  },
});
